export const timer = {
  convertMillisecondsToSeconds: (totalMilliseconds = 0) =>
    (totalMilliseconds / 1000).toFixed(0),
  convertSecondsToMinuteSecondString: (totalSeconds) => {
    totalSeconds = totalSeconds < 0 ? 0 : totalSeconds;
    const minutes = Math.floor(totalSeconds / 60);
    const formattedMinutes = String(minutes).padStart(2, '0');
    const seconds = totalSeconds % 60;
    const formattedSeconds = String(seconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  },
};
